import { type DiscussionLocation } from '@air/analytics';
import { useShortIdContext } from '@air/provider-short-id';

import { useDeleteCommentClick } from '~/swr-hooks/discussions/useDeleteCommentClick';

/**
 * Public share-link surfaces delete comments through the link's shortId, read from
 * ShortIdProvider — mounted under every public asset modal — rather than sniffed from the URL
 * (the share-link preview iframe and the editor's Edit-tab canvas don't live on `/a/…` routes).
 */
export const usePublicDeleteCommentClick = ({ trackLocation }: { trackLocation: DiscussionLocation }) => {
  const { shortId } = useShortIdContext();

  return useDeleteCommentClick({ trackLocation, shortId });
};
